var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPodcast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 35C32.7614 35 35 32.7614 35 30C35 27.2386 32.7614 25 30 25C27.2386 25 25 27.2386 25 30C25 32.7614 27.2386 35 30 35Z",
    stroke: "#E50914",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 19.3992C41.9947 20.7923 43.1011 22.4466 43.8559 24.2676C44.6108 26.0886 44.9993 28.0405 44.9993 30.0117C44.9993 31.983 44.6108 33.9349 43.8559 35.7558C43.1011 37.5768 41.9947 39.2311 40.6 40.6242M19.4 40.5992C18.0054 39.2061 16.899 37.5518 16.1441 35.7308C15.3893 33.9099 15.0007 31.958 15.0007 29.9867C15.0007 28.0155 15.3893 26.0636 16.1441 24.2426C16.899 22.4216 18.0054 20.7673 19.4 19.3742M47.675 12.3242C52.3618 17.0124 54.9947 23.3701 54.9947 29.9992C54.9947 36.6283 52.3618 42.986 47.675 47.6742M12.325 47.6742C7.63826 42.986 5.00537 36.6283 5.00537 29.9992C5.00537 23.3701 7.63826 17.0124 12.325 12.3242",
    stroke: "#E50914",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 19.4005C20.7931 18.0059 22.4475 16.8995 24.2684 16.1446C26.0894 15.3898 28.0413 15.0012 30.0125 15.0012C31.9838 15.0012 33.9357 15.3898 35.7567 16.1446C37.5776 16.8995 39.232 18.0059 40.625 19.4005M12.3251 12.3255C17.0132 7.63874 23.3709 5.00586 30 5.00586C36.6292 5.00586 42.9869 7.63874 47.675 12.3255",
    stroke: "#E50914",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPodcast);
export default __webpack_public_path__ + "static/media/ic_podcast.9620fd90.svg";
export { ForwardRef as ReactComponent };